import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import {RootState} from "../../rootReducer";

export const findTemplatesForUserOrLocation = createAsyncThunk(
  "templateList/findForUserOrLocation",
  async (data, {rejectWithValue, getState}) => {
    const state = getState() as RootState;

    try {
      const {data} = await axiosInstance.get(`${api.baseURL}form`, {
        params: {
          select: "id,name,assignedTo",
          where: JSON.stringify({
            archive: { not: null },
            sourceOrganization: state.userAuthentication.user?.sourceOrganization,
          }),
        }
      });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
